import axios from 'axios';
import store from './store';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_ENDPOINT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

apiClient.interceptors.response.use(
  (response) => {
    if (response.data && response.data.session) {
      store.commit('updateSession', response.data.session);
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;